import React, { useState , useEffect, Suspense, useRef } from "react";
import { decodePermission, permissionLogic, validatePassword, AM_version, scriptControlHeight, mediaControlHeight, dBConn, updateSetUser, logOut } from "./ApiCenter/API_GET";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css';
import { MenuLeft } from "./MenuLeft/MenuLeft";
import { ProfileSettings } from "./pages/profile/profileSettings";
import {InfoProvider}  from './ApiCenter/AM_BackGroundOP';
import Protected from './Protected';
/* projects */
import { ProjectsShow } from "./pages/Projects/01_Projects";
import { ProjectBreakdownfakeLink } from "./pages/Projects/BreakDownSupport/04_02_ProjectBreakdown_fakeLink";
import $ from "jquery";
import VideoPlayer from "./ApiCenter/AudioMateVPlayer";
import { registerLicense } from '@syncfusion/ej2-base';
import { PronunciationsContextProvider } from './pages/Projects/PronunciationContext';
import { ActorScriptContextProvider } from './pages/Projects/ActorScriptContext';
import { SpellCheckContextProvider } from './pages/Projects/SpellCheckContext';
import { FloatingWindowLauncher } from './ApiCenter/FloatingWindow';




const Header = React.lazy(() => import("./Header/Header").then(module => ({ default: module.Header })));
const ProjectOverview = React.lazy(() => import('./pages/Projects/04_01_ProjectOverview').then(module => ({ default: module.ProjectOverview })));
const ProjectsBD = React.lazy(() => import('./pages/Projects/04_02_ProjectBreakdown'));
const ProjectBDBuilder = React.lazy(() => import('./pages/Projects/04_07_ProjectBDBuilder'));
const ProjectsScript = React.lazy(() => import('./pages/Projects/04_03_ProjectScriptTable').then(module => ({ default: module.ProjectsScript })));
const ActorScriptWindow = React.lazy(() => import('./pages/Projects/04_09_ActorScript'));
const PronunciationGlossaries = React.lazy(() => import('./pages/Projects/01_Projects_Pronunciations'));
const ProjectScriptExcel = React.lazy(() => import('./pages/Projects/04_04_ProjectScriptExcel').then(module => ({ default: module.ProjectScriptExcel })));
const ProjectGant = React.lazy(() => import('./pages/Projects/04_05_ProjectGantChart').then(module => ({ default: module.ProjectGant })));
const TrelloProduction = React.lazy(() => import('./pages/Projects/04_06_Trello').then(module => ({ default: module.TrelloProduction })));
const MediaLibrary2 = React.lazy(() => import('./pages/Projects/04_08_MediaFiles_2'));
const PlayerDetachableAudio = React.lazy(() => import("./ApiCenter/DetachableAudioPLayer"));
const PlayerDetachableVideo = React.lazy(() => import("./ApiCenter/DetachableVideoPlayer"));
const AudioMassEditor = React.lazy(() => import('./ApiCenter/AM_AudioEditor'));
const UploadAssets = React.lazy(() => import('./pages/FileTransfer/UploadAssets'));
const DowloadAssets = React.lazy(() => import('./pages/FileTransfer/DowloadAssets'));
const AdminHomePage = React.lazy(() => import('./Admin/ResourceManager_TabComponent').then(module => ({ default: module.AdminHomePage })));
const ApplicationUsers = React.lazy(() => import('./Admin/ResourceManager_ApplicationUsers'));
const ProductionUsers = React.lazy(() => import('./Admin/ResourceManager_Actors'));
const GroupsManagements = React.lazy(() => import('./Admin/ResourceManager_Groups'));
const RecordingStudios = React.lazy(() => import('./Admin/ResourceManager_RecordingStudios').then(module => ({ default: module.RecordingStudios })));
const BankHolidays = React.lazy(() => import('./Admin/ResourceManager_BankHolidays').then(module => ({ default: module.BankHolidays })));
const AMSites = React.lazy(() => import('./Admin/ResourceManager_Sites').then(module => ({ default: module.AMSites })));
const AMClients = React.lazy(() => import('./Admin/ResourceManager_Clients').then(module => ({ default: module.AMClients })));
const AMLanguages = React.lazy(() => import('./Admin/ResourceManager_Languages').then(module => ({ default: module.AMLanguages })));
const AMFranchises = React.lazy(() => import('./Admin/ResourceManager_Franchises').then(module => ({ default: module.AMFranchises })));
const AMRoles = React.lazy(() => import('./Admin/ResourceManager_Roles').then(module => ({ default: module.AMRoles })));

const SchedulerContainer = React.lazy(() => import('./Admin/Scheduler/SchedulerContainer').then(module => ({ default: module.SchedulerContainer })));
const QATags = React.lazy(() => import('./Admin/QATags').then(module => ({ default: module.QATags })));
const RolesPermission = React.lazy(() => import('./Admin_superior/RolesPermission').then(module => ({ default: module.RolesPermission })));
const ChatGPT = React.lazy(() => import('./pages/Projects/ChatGPT'));
const S3Manager = React.lazy(() => import('./Admin/AudioManager/S3Manager').then(module => ({ default: module.S3Manager })));
const AMLogs = React.lazy(() => import('./Admin/ResourceManager_Logs').then(module => ({ default: module.AMLogs })));
const XLOCApi = React.lazy(() => import('./pages/Projects/XLOCApi'));
const ExcelModule = React.lazy(() => import('./pages/SyncFusionTest/SpreedSheet').then(module => ({ default: module.ExcelModule })));
const ApplicationPanel = React.lazy(() => import('./Admin_superior/Application').then(module => ({ default: module.ApplicationPanel })));

/* Metrics */
const Metrics = React.lazy(() => import('./pages/Projects/Metrics').then(module => ({ default: module.Metrics })));
/* help online */
const VideoTutorial = React.lazy(() => import('./pages/Help/videotutorial').then(module => ({ default: module.VideoTutorial })));
const AudioMatePdfGuide = React.lazy(() => import('./pages/Help/pdfguide').then(module => ({ default: module.AudioMatePdfGuide })));
// licence that we have always had
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdEVjXn1YdHRXQmhfWkdx');

$(window).on("resize", function(e) {

    const current = $(window).height();
    const breakdownHeight = current - 305;
    const projectlistHeight = current - 250;

    const bdbuilderHeight = current - 320; 
    const resourceappAppHeight = current - 290; 
    const resourceappActorHeight = current - 290; 
    const resourcegroupsHeight = current - 290;
    const resourcerecstudiosHeight = current - 260;
    const rulesHeight = current - 255;
    const ganttHeight = current - 300;
    const amsites = current - 290;

    document.documentElement.style.setProperty(`--div-height-breakdown`, breakdownHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-breakdown-grid`, (breakdownHeight - 140) + 'px');

    document.documentElement.style.setProperty(`--div-height-breakdown`, breakdownHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-projectlist`, projectlistHeight + 'px');
    
    document.documentElement.style.setProperty(`--div-height-bdbuilder`, bdbuilderHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourceapp`, resourceappAppHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourceactors`, resourceappActorHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourcegroups`, resourcegroupsHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourcerecstudios`, resourcerecstudiosHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-rules`, rulesHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-ganttPlanner`, ganttHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-amsites`, amsites + 'px');
    document.documentElement.style.setProperty(`--div-height-amclients`, amsites + 'px');
    scriptControlHeight(current);
    mediaControlHeight();

});

function invalidCredentials(message){
    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' + 
    message + 
    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + 
    '</div>'
}
function invalidUsername(){
    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' + 
    'Username field must be compiled!' + 
    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + 
    '</div>'
}


function App() {

    const [actor, setActor] = useState(false)
    const [user, setUser] = useState(false)
    const [isloading, setIsLoading] = useState(true)
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    //const [userPermissions, setUserPermissions] = useState({});
    /* change password */
    const [changePasswordMode, setChangePasswordMode] = useState(false)
    const [cssClassPasswordCode, setCssClassPasswordCode] = useState(false)
    const [cssClassPasswordMatch, setCssClassPasswordMatch] = useState(false)
    const [formChangePassword, setFormChangePassword] = useState(false)

    /* text/password */
    const [mainPasswordType, setMainPasswordType] = useState("password")
    const [newPasswordType, setNewPasswordType] = useState("password")
    const [confirmPasswordType, setConfirmPasswordType] = useState("password")

    const [showActorScriptPortal, setShowActorScriptPortal] = useState(false);

    const initialUserData = useRef(null);
    
    useEffect(() => {  
           
        updateSetUser(setUser, setIsLoading);
        
        //const data = localStorage.getItem("pem");
        //if(!data) {
        //    setUser(false);
        //    setIsLoading(false);  
        //    return;
        //}
        dBConn.get('me').then((userData) => {
            if(!userData || userData.error) {
                initialUserData.current = null;
                logOut();
                //localStorage.removeItem("pem");
                //setUser(false);
                //setIsLoading(false);  
                return;
            }
            initialUserData.current = userData;
            //const decodedPermissions = decodePermission(data) 
            //const decodedPermissions = userData['permissions']; 
            //setUserPermissions(decodedPermissions); 
            setUser(userData.id > 0); 
            setIsLoading(false);  
        })   

    }, []);
    
    useEffect(() => {     
        if(user) {
            //const userName = JSON.parse(localStorage.getItem('user') ?? '{}')?.['resourcename'];
            const userName = initialUserData.current?.resourcename;
            window.DD_RUM?.setUser?.({
                name: userName,
            });
        }      
    }, [user])
    
    if(isloading){
        return <span>Loading...</span>
    }

    const handleSubmit = async e => {
        e.preventDefault();

        document.querySelector('#handlelogin').innerHTML = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'

        if(username === '' || password === ''){
            invalidCredentials('Username and Password fields must be compiled!')
            return
        }

        const credentials = { username, password, versionapp: AM_version(), domain: window.location.hostname };
        // send the username and password to the server
        dBConn.post('login=1', credentials).then(response => {
            if(response.vault.status === false){
                invalidCredentials(response.vault.message)     
            } else {
                initialUserData.current = response.userData;
                //axios.defaults.headers.common['Authorization'] = `Bearer ${response.token}`;
                //localStorage.setItem('keyID', response.keyID)
                // Decode the String
                //const decodedPermissions = decodePermission(response.usepem);
                //setUserPermissions(decodedPermissions)
                //localStorage.setItem('user', JSON.stringify(response.response))
                //localStorage.setItem('usertemp', response.responseEnc)
                //localStorage.setItem('pem', response.usepem)
                document.documentElement.style.setProperty(`--zendesstatus`, '1');
                //setUser(Object.keys(decodedPermissions).length > 0);
                setUser(response.userData?.id > 0);
            }
        })
 
    }

    //function refreshStatus(info){   
    //    const permissions = localStorage.getItem("pem");    
    //    if(permissions !== info){
    //        localStorage.setItem('pem', info)
    //        //setUserPermissions(decodePermission(info))
    //    }
    //}

    function gobackToLogin(deleteMessages){
        try{
        document.querySelector('#NewPassword').value = ''
        document.querySelector('#NewPasswordConfirm').value = ''
        } catch(e){}
        if(deleteMessages){
            document.querySelector('#handlelogin').innerHTML = ''
        }
        setChangePasswordMode(false)
        setCssClassPasswordCode(false)
        setCssClassPasswordMatch(false)
        setFormChangePassword(false)

    }

    /*show hide passwords */
    function showHidePassword(type){
        if(type === 'main'){
            if(mainPasswordType === "text"){setMainPasswordType("password")} else {setMainPasswordType("text")}
        }
        if(type === 'new'){
            if(newPasswordType === "text"){setNewPasswordType("password")} else {setNewPasswordType("text")}
        }
        if(type === 'confirm'){
            if(confirmPasswordType === "text"){setConfirmPasswordType("password")} else {setConfirmPasswordType("text")}
        }
    }

    function passwordChange(){
        const usernameValue = username.trim()
        if(usernameValue === ''){
            invalidUsername()
            return
        } else {
            document.querySelector('#handlelogin').innerHTML = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
            const credentials = { usernameValue, any: 'any'};
            // send the username and password to the server
            dBConn.post('passwordchange=1', credentials).then(response => {
                setPassword("")
                if(response.data.vault.status === true){
                    setChangePasswordMode(true)
                    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-success alert-dismissible fade show" role="alert">' + 
                    'An email has been sent to your address!' + 
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + 
                    '</div>'
                } else {
                    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' + 
                    'Username not found!' + 
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + 
                    '</div>'
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
        }
    }
    /* check if the code is valid */
    function inputValidationCode(e){
        if(e.target.value.length === 8){
            setCssClassPasswordCode(true)
            //document.querySelector('#handlelogin').innerHTML = ''
        } else {
            setCssClassPasswordCode(false)
        }
    }

    /* check if the code is valid */
    async function checkValidationCode(){
        if(cssClassPasswordCode){

            const code = document.querySelector('#checkNumberID').value
            if(code.trim().length === 8){
                document.querySelector('#handlelogin').innerHTML = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
                dBConn.post('passwordCheckcode=1', {code, username: username.trim()}).then(response => {
                    if(response.data.status === false){
                        document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' + 
                        response.data.message + 
                        '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + 
                        '</div>'

                        if(response.data.retry === false){
                            gobackToLogin(false)
                        }

                    } else {
                        document.querySelector('#handlelogin').innerHTML = ''
                        setFormChangePassword(true)              
                    }
                })
            }
        }
    }

    /* check if new password matchs */
    function changePasswordValueHandler(e){
        const newPassword = document.querySelector('#NewPassword').value
        const newPasswordConfirm = document.querySelector('#NewPasswordConfirm').value

        if(newPassword === newPasswordConfirm){
            setCssClassPasswordMatch("green")
        } else {
            setCssClassPasswordMatch("red")
        }
    }

    function changePasswordOperation(){
        const newPassword = document.querySelector('#NewPassword').value
        const newPasswordConfirm = document.querySelector('#NewPasswordConfirm').value


        if(newPassword.trim() === ''){

            document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
            'New Password fields must be compiled!' +
            '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
            '</div>'
            return
        }

        document.querySelector('#handlelogin').innerHTML = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'

        if(newPassword === newPasswordConfirm){

            const newPasswordCheck = validatePassword(newPassword)

            if(newPasswordCheck !== true){

                document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
                newPasswordCheck +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                '</div>'
                return
            }

            const credentials = { username,
                                newPassword: newPassword,
                                protectUser: document.querySelector('#checkNumberID').value};
            // send the username and password to the server
            dBConn.post('passwordchangeoperation=1', credentials).then(response => {
                if(response.data.vault.status === true){
                    setChangePasswordMode(false)
                    setCssClassPasswordCode(false)
                    setCssClassPasswordMatch(false)
                    setFormChangePassword(false)
                    document.querySelector('#NewPassword').value = ''
                    document.querySelector('#NewPasswordConfirm').value = ''
                    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                    'Password changed! <br />Enter your new data to access to AudioMate' +
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                    '</div>'
                } else {
                    document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
                    response.data.vault.message + 
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                    '</div>'
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
        } else {
            document.querySelector('#handlelogin').innerHTML = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
            'Password not match!' +
            '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
            '</div>'
        }
    }

    if (user) {   
        return (
            <>  
                <InfoProvider initialData={{...initialUserData.current}}>
                    <ActorScriptContextProvider>
                        <PronunciationsContextProvider>             
                            <SpellCheckContextProvider>  
                                <Router>
                                    {!actor && <Header/>}
                                    {!actor && <MenuLeft />}
            
                                    <div id="audiomatecontrol">
                                        <Suspense fallback={<div>Loading...</div>}>
                                            <Routes>
                                                {!actor && <>          
                                                    <Route exact path="/" element={<ProjectsShow/>}/>
                                                    <Route exact path="/userdata" element={<ProfileSettings/>}/>
                                                    <Route exact path="/projects/:title?" element={<ProjectsShow/>}/>
                                                    <Route path="/uploads/:uploadinfo?" 
                                                        element={
                                                            <Protected permissions={['SourceUploadFiles', 'TargetUploadFiles']}>
                                                                <UploadAssets/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route path="/downloads/:downloadinfo?" 
                                                        element={
                                                            <Protected permissions={['SourceDownloadFiles', 'TargetDownloadFiles']}>
                                                                <DowloadAssets/>
                                                            </Protected>     
                                                        }
                                                    />
                                                    <Route path="/metrics" 
                                                        element={
                                                            <Protected onlyInternal={true}>
                                                                <Metrics/>
                                                            </Protected>
                                                        }     
                                                    />
                                                    <Route path="/videos" element={<VideoPlayer/>}/>
                                                    <Route exact path="/projectsdetails/:id/overview"
                                                        element={
                                                            <Protected permissions={['view_Overview']}>
                                                                    <ProjectOverview/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/projectsdetails/:id/breakdown" 
                                                        element={
                                                            <Protected permissions={['view_Breakdown']}>
                                                                    <ProjectsBD/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/redirectdb/:id" element={<ProjectBreakdownfakeLink/>}/>
                                                    <Route exact path="/qatags" 
                                                        element={
                                                            <Protected permissions={['showQATagsModule']}>
                                                                <QATags/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/xloc"  
                                                        element={
                                                            <Protected permissions={['xlocModule']}>
                                                                <XLOCApi/>                                                
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/projectsdetails/:id/script" 
                                                        element={
                                                            <Protected permissions={['view_ScriptBase']}>
                                                                <ProjectsScript data={{showActorScriptPortal, setShowActorScriptPortal}}/>  
                                                            </Protected>        
                                                        }
                                                    /> 
                                                    <Route exact path="/projectsdetails/:id/excel"
                                                        element={
                                                            <Protected permissions={['view_ExcelModule']}>
                                                                <ProjectScriptExcel/>
                                                            </Protected>      
                                                        }
                                                    />
                                                    <Route exact path="/projectsdetails/:id/gantt" 
                                                        element={
                                                            <Protected permissions={['view_GantChart']}>
                                                                <ProjectGant/>
                                                            </Protected>      
                                                        }
                                                    />
                                                    <Route exact path="/projectsdetails/:id/bdbuilder" 
                                                        element={
                                                            <Protected permissions={['view_BreakDownBuilder']}>
                                                                <ProjectBDBuilder/>
                                                            </Protected>        
                                                        }
                                                    />
                                                    <Route exact path="/projectsdetails/:id/production" 
                                                        element={
                                                            <Protected permissions={['view_Trello']}>
                                                                <TrelloProduction/>
                                                            </Protected>     
                                                        }
                                                    />
                                                    {/*
                                                    <Route exact path="/projectsdetails/:id/medianewmedia" 
                                                        element={
                                                            <Protected permissions={['view_Media']}>
                                                                <MediaLibrary/>
                                                            </Protected>
                                                        }
                                                    /> 
                                                    */}
                                                    <Route exact path="/projectsdetails/:id/media" 
                                                        element={
                                                            <Protected permissions={['view_Media']}>
                                                                <MediaLibrary2/>
                                                            </Protected>        
                                                        }
                                                    />
                                                    {/* resources */}
                                                    <Route exact path="/admin" 
                                                        element={
                                                            <Protected permissions={['createAccount']}>
                                                                <AdminHomePage/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/appresources" 
                                                        element={
                                                            <Protected permissions={['createAccount']}>
                                                                <ApplicationUsers/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/sites" 
                                                        element={
                                                            <Protected permissions={['manageSites']}>
                                                                <AMSites/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/clients" 
                                                        element={
                                                            <Protected permissions={['manageClients']}>
                                                                <AMClients/>
                                                            </Protected> 
                                                        }
                                                    />
                                                    <Route exact path="/languages" 
                                                        element={
                                                        <Protected permissions={['manageLanguages']}>
                                                                <AMLanguages/>
                                                            </Protected> 
                                                        }
                                                    />
                                                    <Route exact path="/franchises" 
                                                        element={
                                                            <Protected permissions={['manageFranchise']}>
                                                                <AMFranchises/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/roles" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <AMRoles/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/prodresources" 
                                                        element={
                                                            <Protected permissions={['createActors']}>
                                                                <ProductionUsers/>
                                                            </Protected>   
                                                        }
                                                    />
                                                    <Route exact path="/teams" 
                                                        element={
                                                            <Protected permissions={['createTeams']}>
                                                                <GroupsManagements/>
                                                            </Protected>  
                                                        }
                                                    />
                                                    <Route exact path="/recbooths" 
                                                        element={
                                                            <Protected permissions={['manageRecBooths']}>
                                                                <RecordingStudios/>
                                                            </Protected>   
                                                        }
                                                    />
                                                    <Route exact path="/bankholidays" 
                                                        element={
                                                            <Protected permissions={['bankHolidays']}>
                                                                <BankHolidays/>
                                                            </Protected> 
                                                        }
                                                    />
                                                    {/*<Route exact path="/gantt" element={<Gantt/>}/>*/}
                                                    {/*
                                                    <Route exact path="/adaptMarks" 
                                                        element={
                                                            <Protected permissions={['setAdaptationMarks']}>
                                                                <AdaptationMarkL1/>
                                                            </Protected>
                                                        }
                                                    />*/
                                                    }
                                                    <Route exact path="/pronglossaries" 
                                                        element={
                                                            <Protected permissions={['setPronunciationGlossaries']}>
                                                                <PronunciationGlossaries/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/scheduler" 
                                                        element={
                                                            <Protected permissions={['view_Scheduler']}>
                                                                <SchedulerContainer/>
                                                            </Protected>  
                                                        }
                                                    />
                                                    {/* resources temporany */}
                                                    <Route exact path="/rolePermissions" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <RolesPermission/>
                                                            </Protected>  
                                                        }
                                                    />
                                                    <Route exact path="/application" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <ApplicationPanel/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/spreedsheet" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <ExcelModule/>
                                                            </Protected>
                                                        }
                                                    />
                                                    <Route exact path="/s3manager" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <S3Manager/>
                                                            </Protected> 
                                                        }
                                                    />
                                                    <Route exact path="/logs" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <AMLogs/> 
                                                            </Protected>  
                                                        }
                                                    />
                                                    <Route exact path="/chatai" 
                                                        element={
                                                            <Protected permissions={['UITemp']}>
                                                                <ChatGPT/>
                                                            </Protected>  
                                                        }
                                                    />
                                                    <Route exact path="/help" element={<VideoTutorial/>}/>
                                                    <Route exact path="/documentation/:id" element={<AudioMatePdfGuide/>}/>
                                                </>}
                                                {/*<Footer />*/}
                                                {/*permissionLogic(userPermissions, 'view_ScriptBase') && */
                                                <Route exact path="/actorscript" 
                                                    element={
                                                        <Protected permissions={['view_ScriptBase']}>
                                                            <ActorScriptWindow data={{set:setActor}}/>
                                                        </Protected>
                                                    }
                                                />}
                                                <Route exact path="/AudiomatePlayer" element={<PlayerDetachableAudio />}/>
                                                <Route exact path="/AudioMateVPlayer" element={<PlayerDetachableVideo /*data={{set:setPlayer}}*//>}/>
                                                <Route exact path="/AudiomateEditor" element={<AudioMassEditor />}/>
                                            </Routes>
                                        </Suspense>
                                    </div>
                                </Router>
                            </SpellCheckContextProvider>
                        </PronunciationsContextProvider>
                    </ActorScriptContextProvider>
                    <FloatingWindowLauncher/>
                </InfoProvider>        
            </>

        )
    } else {
        // if there's no user, show the login form
        return (

            <>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                          <div className="d-flex justify-content-center py-4">
                              <a href="index.html" className="logo d-flex align-items-center w-auto">
                                  <img src="/assets/img/kantan-audiomate_logo-color.png" alt="" />
                                   {/*<span className="d-none d-lg-block">AudioMate</span>*/}
                              </a>
                          </div>
                          <div className="card mb-3">
                              <div className="card-body">
                                  <div className="pt-4 pb-2">
                                      <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                                      <p className="text-center small">Enter your username &amp; password to login</p>
                                  </div>
                                  <form className="row g-3 needs-validation" noValidate="" onSubmit={handleSubmit}>
                                    {changePasswordMode === false &&
                                      <>                                    
                                      <div className="col-12">
                                          <label htmlFor="Username" className="form-label">Username</label>
                                          <div className="input-group has-validation">
                                              <span className="input-group-text" id="inputGroupPrepend"><i className="bx bxs-user-circle"></i></span>
                                              <input type="text" name="username" className="form-control" id="Username" value={username} required="" onChange={({ target }) => setUsername(target.value)} autoComplete="off" spellCheck="false"/>
                                              <div className="invalid-feedback">Please enter your username.</div>
                                          </div>
                                      </div>

                                      <div className="col-12">
                                          <label htmlFor="Password" className="form-label">Password</label>
                                          <div className="input-group mb-3">
                                            <input type={mainPasswordType} name="password" className="form-control" id="Password" value={password} required="" onChange={({ target }) => setPassword(target.value)}/>
                                            <span className="input-group-text asimulatedlink" onClick={() =>showHidePassword('main')}><i className="bi bi-eye-slash"></i></span>
                                          </div>
                                          <div className="invalid-feedback">Please enter your password!</div>
                                      </div>
                                      <div className="col-12 t-20 text-end">
                                          <span className="asimulatedlink" onClick={passwordChange}>Change Password</span>
                                      </div>
                                      </>}
                                      {/********************************************************************** */}
                                      {changePasswordMode === true &&
                                      <>
                                      <div className="col-12 t-20 text-end">
                                          <span className="asimulatedlink" onClick={() => gobackToLogin(true)}>Go Back</span>
                                      </div>
                                      <div className="col-12">
                                          <label htmlFor="checkNumberID" className="form-label">Insert the code sent at your email address</label>
                                          <div className="btn-group text-center" role="group" aria-label="ResetPassword" style={{textAlign: 'center'}}>
                                                <input type="text" id="checkNumberID" className="form-control form-control-sm" style={{width: '100px', color: cssClassPasswordCode ? 'green' : 'red'}} onChange={inputValidationCode} disabled={formChangePassword} />
                                                <button type="button" className="btn btn-outline-primary btn-sm" style={{width: '100px'}} onClick={checkValidationCode} disabled={!cssClassPasswordCode || formChangePassword}>Validate</button>
                                          </div>
                                          <div className="invalid-feedback">Please enter your password!</div>
                                      </div>
                                      {/********PASSWORD************************************************************** */}
                                      </>}
                                      {formChangePassword &&
                                      (<>

                                        <div className="col-12">
                                          <label htmlFor="NewPassword" className="form-label">New Password</label>
                                          <div className="input-group mb-3">
                                            <input type={newPasswordType} name="password" className="form-control" id="NewPassword" style={{color: cssClassPasswordMatch}} required="" onChange={changePasswordValueHandler}/>
                                            <span className="input-group-text asimulatedlink" onClick={() =>showHidePassword('new')}><i className="bi bi-eye-slash"></i></span>
                                        </div>

                                      </div>
                                      {/**********CONFIRM PASSWORD************************************************************ */}
                                      <div className="col-12">
                                          <label htmlFor="NewPasswordConfirm" className="form-label">New Password Confirm</label>
                                          <div className="input-group mb-3">
                                            <input type={confirmPasswordType} name="password" className="form-control" id="NewPasswordConfirm" style={{color: cssClassPasswordMatch}} required="" onChange={changePasswordValueHandler}/>
                                            <span className="input-group-text asimulatedlink" onClick={() =>showHidePassword('confirm')}><i className="bi bi-eye-slash"></i></span>
                                          </div>
                                      </div>

                                      <div className="col-12 t-20">
                                          <label htmlFor="button" className="form-label"></label>
                                          <button name="button" className="btn btn-primary w-100" type="button" onClick={changePasswordOperation}>Change Password</button>
                                      </div>
                                        </>)}
                                      {/*************END********************************************************* */}
                                      
                                      {changePasswordMode === false &&
                                      <>
                                      <div className="col-12 t-20">
                                          <label htmlFor="button" className="form-label"></label>
                                          <button name="button" className="btn btn-primary w-100" type="submit">Login</button>
                                      </div>
                                      </>}
                                      <div id="handlelogin"></div>

                                  </form>
                              </div>
                              
                          </div>

                      </div>
                  </div>
              </div>
          </>
        );

    }

  
}

export default App;
